import React, { StrictMode, Suspense } from 'react';
import { Provider } from 'react-redux';
import { CssBaseline, LinearProgress, ThemeProvider } from '@material-ui/core';
import { MuiPickersUtilsProvider } from '@material-ui/pickers';
import LuxonUtils from '@date-io/luxon';

import { getBrowserHistory } from 'browserHistory';

import { makeTheme } from 'theme';

import { validateLocalStorage } from 'core/storage/storage';

import { ErrorBoundary } from 'components/ErrorBoundary';

import { Routes } from 'Routes';
import { makeStore } from 'state';
import { SnackbarContainer } from 'components/SnackbarContainer/SnackbarContainer';
import { CookiesBanner } from './components/CookiesBanner/CookiesBanner';

validateLocalStorage();

const theme = makeTheme();

const history = getBrowserHistory();
const store = makeStore(history);

export const App = () => {
    return (
        <StrictMode>
            <ErrorBoundary>
                <Provider store={store}>
                    <ThemeProvider theme={theme}>
                        <MuiPickersUtilsProvider utils={LuxonUtils} locale="ru">
                            <Suspense fallback={<LinearProgress />}>
                                <CssBaseline />
                                <SnackbarContainer />
                                <Routes history={history} />
                                <CookiesBanner />
                            </Suspense>
                        </MuiPickersUtilsProvider>
                    </ThemeProvider>
                </Provider>
            </ErrorBoundary>
        </StrictMode>
    );
};
